interface SiemData {
    endpoints: number;
    workstations: number;
}

interface SiemCalculatorProps extends SiemData {
    endpoints: number;
    workstations: number;
    HTMLPrices: [HTMLElement, HTMLElement, HTMLElement];
    HTMLDurations: [HTMLElement, HTMLElement, HTMLElement];
    currency?: string;
    // eslint-disable-next-line no-unused-vars
    formatDuration?: (duration: number) => string;
    // eslint-disable-next-line no-unused-vars
    formatPrice?: (price: number, currency: string) => string;
}

export class SiemCalculator implements SiemCalculatorProps {
    currency = 'EUR';
    endpoints: number;
    workstations: number;
    HTMLPrices: [HTMLElement, HTMLElement, HTMLElement];
    HTMLDurations: [HTMLElement, HTMLElement, HTMLElement];
    // eslint-disable-next-line no-unused-vars
    formatDuration?: (duration: number) => string;
    // eslint-disable-next-line no-unused-vars
    formatPrice?: (price: number, currency: string) => string;

    constructor(data: SiemCalculatorProps) {
        Object.assign(this, data);
        this.calculate();
    }

    public updateValue(data: Partial<SiemCalculatorProps>) {
        if (data.endpoints) this.endpoints = data.endpoints;
        if (data.workstations) this.workstations = data.workstations;
        this.calculate();
    }

    private formatPriceNumber(price: number) {
        return price.toLocaleString('en').replace(',', ' ');
    }
    private getPriceFormated(price: number) {
        if (typeof this.formatPrice === 'function') {
            return this.formatPrice(price, this.currency);
        }

        switch (this.currency) {
            case 'USD':
                return `$${this.formatPriceNumber(price)}`;
            case 'EUR':
                return `€${this.formatPriceNumber(price)}`;
            default:
                return `€${this.formatPriceNumber(price)}`;
        }
    }
    private calculate() {
        const prices = this.prices;
        const durations = this.durations;

        this.HTMLPrices.forEach((HTMLElement, index) => {
            HTMLElement.textContent = this.getPriceFormated(prices[index]);
        });
        this.HTMLDurations.forEach((HTMLElement, index) => {
            const textContent =
                this.formatDuration?.(durations[index]) || durations[index];

            HTMLElement.textContent = `${textContent}`;
        });
    }

    private round(value: number, decilam = 0) {
        return Number(value.toFixed(decilam));
    }

    private get BASIC_RATE() {
        return 50;
    }
    private get MARGIN() {
        return 2;
    }
    private get BASIC_PRICE() {
        return 40;
    }

    private get durations() {
        const val1 = Math.ceil(4 * this.workstations);
        const val2 = Math.ceil(8 * this.workstations * this.endpoints);
        const val3 = Math.ceil(12 * this.workstations * this.endpoints);

        return [val1, val2, val3].map((v) => this.round(v));
    }
    private get prices() {
        return this.durations.map((duration) => {
            const actualDuration = duration / 2;

            return this.round(
                this.BASIC_RATE *
                    this.MARGIN *
                    this.BASIC_PRICE *
                    actualDuration,
                2
            );
        });
    }
}
